import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import utensilsIcon from 'assets/img/icons/utensils.svg';
import editIcon from 'assets/img/icons/edit.svg';

class AddIngredientMenu extends React.Component {
  render() {
    return (
      <div className="page-dropdown">
        <Dropdown>
          <Dropdown.Toggle>
            <i className="fas fa-plus"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Toggle>
              <i className="fas fa-times"></i>
            </Dropdown.Toggle>
            <div className="dropdown-content">
              <Dropdown.Item
                onClick={this.props.handleAddIngredient}
                className="btn btn-primary"
              >
                <img src={utensilsIcon} /> Add Ingredient
              </Dropdown.Item>
              {!this.props.showTip && (
                <Dropdown.Item
                  onClick={this.props.handleAddTip}
                  className="btn btn-primary"
                >
                  <img src={editIcon} /> Add Tip
                </Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default AddIngredientMenu;
